import api from './request'

const scanTextTest = () => {
    return api.getPromise('test/scanTextTest', {})
}


export default {
    scanTextTest
}


// WEBPACK FOOTER //
// ./src/request/testApi.js